const gm_authFailure = () => {
  window.dispatchEvent(new CustomEvent('InvalidGoogleMapsKey'));
};

// @ts-ignore
window.gm_authFailure = gm_authFailure;
